import { Box, Flex } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { CloseIcon, FileNotesIcon } from 'Asset/icon';
import { Condition, Iteration } from 'Component/others';
import UploadFile from 'UiKit/drop-zone';
import { TextBold, TextMedium, TextRegular, TextSemiBold } from 'UiKit/typography';

import styles from './styles.module.css';

const UploadImage = ({ form }) => {
  const { t } = useTranslation('host-reschedule');
  const maxImageSize = 5242880;
  const { watch, setValue } = form;
  const { files } = watch();

  const onRemoveImage = (index) => {
    setValue(
      'files',
      files.filter((_, idx) => index !== idx)
    );
  };

  return (
    <Box className={styles['upload-image__container']}>
      <TextBold className={styles['upload-image__title-step-text']}>
        {t('attachment.label')} <span>*</span>
      </TextBold>
      <TextMedium className={styles['upload-image__caption-attachment']}>{t('attachment.hint')}</TextMedium>
      <Condition statement={files.length < 3}>
        <UploadFile
          maxFiles={3}
          titleText={t('attachment.tap_to_upload')}
          descText={t('attachment.format_hint')}
          accept={{
            'image/jpeg': ['.jpeg', '.jpg'],
            'image/png': ['.png'],
          }}
          maxSize={maxImageSize}
          data-testid="upload-image__upload-file"
          onDrop={(selectedFiles) => setValue('files', [...files, ...selectedFiles])}
        />
      </Condition>
      <Box className={styles['upload-image__files-container']}>
        <Iteration
          items={files}
          render={(file, index) => {
            return (
              <Box className={styles['upload-image__file-card']} key={index}>
                <Flex gap={'15px'} className={styles['upload-image__file-card--container']}>
                  <FileNotesIcon width="22px" height="22px" color="var(--color-info70)" />
                  <Box className={styles['upload-image__file-card--text']}>
                    <TextSemiBold className={styles['upload-image__file-card--filename']}>{file.name}</TextSemiBold>
                    <TextRegular className={styles['upload-image__file-card--filesize']}>{(file?.size / 1024).toFixed(2)}KB</TextRegular>
                  </Box>
                </Flex>

                <Box className={styles['upload-image__delete--container']}>
                  <CloseIcon
                    size="16px"
                    color="var(--color-info60)"
                    onClick={() => onRemoveImage(index)}
                    data-testid="upload-image__delete-file"
                    className={styles['upload-image__file-card--delete']}
                  />
                </Box>
              </Box>
            );
          }}
        />
      </Box>
    </Box>
  );
};

export default UploadImage;
